"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.fetchHook = fetchHook;
exports.AbortController = exports.AbortSignal = exports.Headers = exports.fetch = void 0;

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

// TODO: Move to the AD-IAM-EndUserExperiences repo.

/**
 * Simplified version of the experimental `AbortSignal` used to control
 * cancelable operations (like fetch).
 */

/**
 * Simplified version of the experimental `AbortController` used to control
 * cancelable operations (like fetch).
 */

/**
 * A simplified subset of the Fetch API `RequestInit` type.
 */

/**
 * A simplified subset of the Fetch API `Response` type.
 */

/**
 * A simplified version of the Fetch API `fetch` function.
 */
var HeadersPolyfill = /*#__PURE__*/function () {
  function HeadersPolyfill() {
    var _this = this;

    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, HeadersPolyfill);
    this._map = new _map.default();

    if (typeof source === 'string') {
      var _context;

      (0, _forEach.default)(_context = source.split(/\r\n/)).call(_context, function (header) {
        var match = header.match(/^([^:]+):\s*(.*)$/);

        if (match) {
          var _match = (0, _slicedToArray2.default)(match, 3),
              _name = _match[1],
              _value = _match[2];

          _this.append(_name, _value);
        }
      });
    } else if (typeof (0, _forEach.default)(source) === 'function') {
      var _headers = source;
      (0, _forEach.default)(_headers).call(_headers, function (value, name) {
        return _this.append(name, value);
      });
    } else {
      var _context2;

      var record = source;
      (0, _forEach.default)(_context2 = (0, _keys.default)(record)).call(_context2, function (name) {
        _this.append(name, record[name]);
      });
    }
  }

  (0, _createClass2.default)(HeadersPolyfill, [{
    key: "append",
    value: function append(name, value) {
      var _context3;

      name = name.toLowerCase();

      var current = this._map.get(name);

      this._map.set(name, current != null ? (0, _concat.default)(_context3 = "".concat(current, ", ")).call(_context3, value) : value);
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      this._map.delete(name.toLowerCase());
    }
  }, {
    key: "get",
    value: function get(name) {
      var _this$_map$get;

      return (_this$_map$get = this._map.get(name.toLowerCase())) !== null && _this$_map$get !== void 0 ? _this$_map$get : null;
    }
  }, {
    key: "has",
    value: function has(name) {
      return this._map.has(name.toLowerCase());
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this._map.set(name.toLowerCase(), value);
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn, thisArg) {
      var _context4,
          _this2 = this;

      (0, _forEach.default)(_context4 = this._map).call(_context4, function (value, key) {
        return callbackfn.call(thisArg, value, key, _this2);
      });
    }
  }]);
  return HeadersPolyfill;
}();

var AbortSignalPolyfill = /*#__PURE__*/function () {
  function AbortSignalPolyfill() {
    (0, _classCallCheck2.default)(this, AbortSignalPolyfill);
    this._listeners = [];
    this._aborted = false;
  }

  (0, _createClass2.default)(AbortSignalPolyfill, [{
    key: "addEventListener",
    value: function addEventListener(name, listener) {
      if (name === 'abort') {
        this._listeners.push(listener);
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, listener) {
      if (name === 'abort') {
        var _context5;

        this._listeners = (0, _filter.default)(_context5 = this._listeners).call(_context5, function (l) {
          return l === listener;
        });
      }
    }
  }, {
    key: "aborted",
    get: function get() {
      return this._aborted;
    }
  }]);
  return AbortSignalPolyfill;
}();

var AbortControllerPolyfill = /*#__PURE__*/function () {
  function AbortControllerPolyfill() {
    (0, _classCallCheck2.default)(this, AbortControllerPolyfill);
    this.signal = new AbortSignalPolyfill();
  }

  (0, _createClass2.default)(AbortControllerPolyfill, [{
    key: "abort",
    value: function abort() {
      var _context6;

      this.signal._aborted = true;
      (0, _forEach.default)(_context6 = (0, _toConsumableArray2.default)(this.signal._listeners)).call(_context6, function (listener) {
        return listener();
      });
    }
  }]);
  return AbortControllerPolyfill;
}();

var fetchImplementation;

if ('fetch' in window) {
  fetchImplementation = function fetchImplementation(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$method = _ref.method,
        method = _ref$method === void 0 ? 'GET' : _ref$method,
        simpleSignal = _ref.signal,
        init = (0, _objectWithoutProperties2.default)(_ref, ["method", "signal"]);

    var signal = null;

    if (simpleSignal instanceof window.AbortSignal) {
      signal = simpleSignal;
    } else if (simpleSignal) {
      var controller = new window.AbortController();
      signal = controller.signal;

      if (simpleSignal.aborted) {
        controller.abort();
      } else {
        simpleSignal.addEventListener('abort', function () {
          return controller.abort();
        });
      }
    }

    return window.fetch(url, (0, _objectSpread2.default)({
      method: method,
      signal: signal
    }, init));
  };
} else if ('XMLHttpRequest' in window) {
  fetchImplementation = function fetchImplementation(url) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$method = _ref2.method,
        method = _ref2$method === void 0 ? 'GET' : _ref2$method,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === void 0 ? {} : _ref2$headers,
        body = _ref2.body,
        signal = _ref2.signal;

    return new _promise.default(function (resolve, reject) {
      try {
        var xhr = new window.XMLHttpRequest();
        xhr.addEventListener('load', function () {
          var blob = xhr.response; // Polyfill for text() is not supported in IE 11

          var text = function text() {
            return new _promise.default(function (res, rej) {
              var reader = new FileReader();

              reader.onloadend = function () {
                if (typeof reader.result === 'string') {
                  res(reader.result);
                } else {
                  rej(Error('failed to read blob as text'));
                }
              };

              reader.onerror = function () {
                return reject(new Error('failed to read blob as text'));
              };

              reader.readAsText(blob);
            });
          };

          resolve({
            url: xhr.responseURL || url,
            ok: Math.floor(xhr.status / 100) === 2,
            status: xhr.status,
            headers: new HeadersPolyfill(xhr.getAllResponseHeaders()),
            arrayBuffer: function () {
              var _arrayBuffer = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                return _regenerator.default.wrap(function _callee$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", blob.arrayBuffer());

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee);
              }));

              function arrayBuffer() {
                return _arrayBuffer.apply(this, arguments);
              }

              return arrayBuffer;
            }(),
            text: text,
            json: function json() {
              return text().then(function (t) {
                return JSON.parse(t);
              });
            }
          });
        });
        xhr.addEventListener('abort', function () {
          reject(Error('request aborted'));
        });
        xhr.addEventListener('error', function () {
          reject(Error('request failed'));
        });
        xhr.open(method.toUpperCase(), url);
        xhr.responseType = 'blob';

        if (typeof (0, _forEach.default)(headers) === 'function') {
          (0, _forEach.default)(headers).call(headers, function (value, name) {
            return xhr.setRequestHeader(name, value);
          });
        } else {
          var _context8;

          (0, _forEach.default)(_context8 = (0, _keys.default)(headers)).call(_context8, function (name) {
            var value = headers[name];
            xhr.setRequestHeader(name, value);
          });
        }

        xhr.send(body);

        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
          xhr.abort();
        } else {
          signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function () {
            return xhr.abort();
          });
        }
      } catch (err) {
        reject(err);
      }
    });
  };
} else {
  fetchImplementation = function fetchImplementation() {
    throw Error('no request implementation available (missing: fetch, XMLHttpRequest)');
  };
} // Hooks

/**
 * A request matching function used with fetch hooks. It should return true
 * if the hook handler should be invoked.
 */


var fetchHooks = [];
/**
 * A partial implementation of the Fetch API.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * ### Limitations
 * - Only the `method`, `headers`, `body`, and `signal` options are supported.
 * - Only `string` and `ArrayBuffer` body types are supported.
 * - Only the `ok`, `status`, `headers`, `text()`, `json()`, and
 * `arrayBuffer()` response properties are supported.
 */

var fetch = function fetch(url, options) {
  if (process.env.NODE_ENV !== 'production' && fetchHooks.length > 0) {
    var mock = (0, _find.default)(fetchHooks).call(fetchHooks, function (m) {
      return m.match(url, options);
    });

    if (mock) {
      return mock.handler(url, options);
    }
  }

  return fetchImplementation(url, options);
};
/**
 * Intercept and handle a matching request.
 *
 * @param match Match function which should return true if the handler should
 * be invoked.
 * @param handler Handle the request when the match function returns true.
 * @returns A function which can be called to remove the hook.
 */


exports.fetch = fetch;

function fetchHook(match, handler) {
  var hook = {
    match: match,
    handler: handler
  };
  fetchHooks.push(hook);
  return function () {
    fetchHooks = (0, _filter.default)(fetchHooks).call(fetchHooks, function (m) {
      return m !== hook;
    });
  };
}

var _Headers = 'Headers' in window ? window.Headers : HeadersPolyfill;

exports.Headers = _Headers;

var _AbortSignal = 'AbortSignal' in window ? window.AbortSignal : AbortSignalPolyfill;

exports.AbortSignal = _AbortSignal;

var _AbortController = 'AbortController' in window ? window.AbortController : AbortControllerPolyfill;

exports.AbortController = _AbortController;